/**
 * Product buy-box: Buy more, save more tier selection.
 * Updates Shopify OptionSelectors / variant select so price + ATC use the chosen pack.
 */
(function ($) {
  'use strict';

  function findProductRoot($el) {
    var $root = $el.closest('[class*="js-product-"]');
    if ($root.length) {
      return $root;
    }
    return $el.closest('form').parent();
  }

  function findProductForm($btn) {
    return $btn.closest('form.js-product-form, form.product-single__form, form');
  }

  function setCurrentTier($wrap, variantId) {
    var idStr = String(variantId);
    $wrap.find('[data-product-pack-tier]').each(function () {
      var $item = $(this);
      if (String($item.attr('data-variant-id')) === idStr) {
        $item.addClass('cart-pack-tiers__item--current').attr('aria-current', 'true');
      } else {
        $item.removeClass('cart-pack-tiers__item--current').removeAttr('aria-current');
      }
    });
  }

  function selectVariant($form, $btn) {
    var variantId = String($btn.attr('data-variant-id'));
    var optionValue = $btn.attr('data-option-value') || $btn.find('.cart-pack-tiers__label').text().trim();
    var $master = $form.find('select[name="id"], select.js-product-variant-select').first();
    var $optionSelectors = $form.find('.single-option-selector');

    // Prefer OptionSelectors dropdowns when present (Venue theme)
    if ($optionSelectors.length && optionValue) {
      var matched = false;
      $optionSelectors.each(function () {
        var $sel = $(this);
        var hasOption = $sel.find('option').filter(function () {
          return $(this).val() === optionValue || $(this).text().trim() === optionValue;
        }).length;
        if (hasOption) {
          $sel.val(optionValue).trigger('change');
          matched = true;
        }
      });
      if (matched) {
        return true;
      }
    }

    if ($master.length) {
      $master.val(variantId).trigger('change');
      return true;
    }
    return false;
  }

  $(document).on('click', '[data-product-pack-tier]', function (evt) {
    evt.preventDefault();
    var $btn = $(this);
    if ($btn.is(':disabled')) {
      return;
    }
    if ($btn.hasClass('cart-pack-tiers__item--current')) {
      return;
    }

    var $wrap = $btn.closest('[data-product-pack-tiers]');
    var $form = findProductForm($btn);
    if (!$form.length) {
      return;
    }

    setCurrentTier($wrap, $btn.attr('data-variant-id'));
    selectVariant($form, $btn);

    var $qty = $form.find('input[name="quantity"]');
    if ($qty.length) {
      $qty.val(1);
    }
  });

  // Keep highlight in sync if variant changes elsewhere
  document.addEventListener('venue:variant:update', function (evt) {
    var detail = evt.detail || {};
    if (!detail.variant || !detail.product) {
      return;
    }
    var productId = detail.product.id;
    var $root = $('.js-product-' + productId);
    var $wrap = $root.find('[data-product-pack-tiers]');
    if ($wrap.length) {
      setCurrentTier($wrap, detail.variant.id);
    }
  });
  
  // BIOE welcome discount savings summary
  function updateBioePromo($wrap) {
    var $summary = $wrap.find('[data-bioe-promo-summary]');

    if (!$summary.length) return;

    var active = false;
    try {
      active = sessionStorage.getItem('bioe_discount_active') === 'BIOENEW10';
    } catch (e) {}

    if (!active) {
      $summary.prop('hidden', true);
      return;
    }

    var $tier = $wrap.find(
      '[data-product-pack-tier].cart-pack-tiers__item--current'
    ).first();

    if (!$tier.length) {
      $tier = $wrap.find('[data-product-pack-tier]').first();
    }

    if (!$tier.length) return;

    var price = Number($tier.attr('data-price'));
    var compare = Number($tier.attr('data-compare'));

    if (!Number.isFinite(price) || price < 0) return;
    if (!Number.isFinite(compare) || compare < price) {
      compare = price;
    }

    // Shopify Liquid prices are expressed in cents.
    var promoSaving = Math.round(price * 0.10);
    var finalPrice = price - promoSaving;
    var totalSaving = compare - finalPrice;

function money(cents) {
  var currencyInfo = window.Shopify && window.Shopify.currency;
  var currency = currencyInfo && currencyInfo.active
    ? currencyInfo.active
    : 'SGD';

  return new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: currency
  }).format(cents / 100);
}

    $summary.find('[data-bioe-package-price]')
      .text(money(price));

    $summary.find('[data-bioe-promo-saving]')
      .text('-' + money(promoSaving));

    $summary.find('[data-bioe-original-price]')
      .text(compare > finalPrice ? money(compare) : '');

    $summary.find('[data-bioe-final-price]')
      .text(money(finalPrice));

    $summary.find('[data-bioe-total-saving]')
      .text('Total savings ' + money(totalSaving));

    $summary.prop('hidden', false);
  }

  // Refresh whenever a package is selected.
  var originalSetCurrentTier = setCurrentTier;

  setCurrentTier = function ($wrap, variantId) {
    originalSetCurrentTier($wrap, variantId);
    updateBioePromo($wrap);
  };

  // Initialise on page load and when Shopify reloads a section.
  function initBioePromo() {
    $('[data-product-pack-tiers]').each(function () {
      updateBioePromo($(this));
    });
  }

  $(initBioePromo);
  $(document).on('shopify:section:load', initBioePromo);

  // Refresh savings when the selected currency changes.
$(document).on('click', '#currency-list-header a[data-value]', function () {
  setTimeout(initBioePromo, 300);
});

  // Also update immediately after clicking a package.
  $(document).on('click', '[data-product-pack-tier]', function () {
    updateBioePromo($(this).closest('[data-product-pack-tiers]'));
  });
})(jQuery);
